document.addEventListener("DOMContentLoaded", function () {

    /* --- pp-banner.liquid start --- */
    const hpDropdownValues = localStorage.getItem("homepageDropdownValues");

    const vehicleInfo = {
        brand: "",
        model: "",
        year: "",
        variantID: "",
        details: "",
    };

    let defaultPPBreadcrumb = document.querySelector(".default-pp-breadcrumb");
    let defaultProductPageDropdown = document.querySelector(".default-pp-dropdown");
    let homepageProductDropdown = document.querySelector(".hp-pp-dropdown");
    let addToCartHP = document.querySelector(".hp-pp-dropdown #customAddToCartBtn");
    let dropdownChevronIcon = document.querySelector(".dropdown-chevron-icon");

    ppInitConditions();
    ppDefaultBreadCrumb();

    // banner main functions start
    function ppInitConditions() {
        if (hpDropdownValues) {
            let carInfo = JSON.parse(hpDropdownValues);
            vehicleInfo.brand = carInfo.brand;
            vehicleInfo.model = carInfo.model;
            vehicleInfo.variantID = carInfo.variantID;
            vehicleInfo.year = carInfo.year;
            vehicleInfo.engineCode = carInfo.engineCode;
            vehicleInfo.details = carInfo.details;
            whichModel = vehicleInfo.model.toLowerCase().trim().replaceAll(" ", "-");

            fillBreadcrumbs();

            if (homepageProductDropdown) {
                homepageProductDropdown.style.display = "block";
            }

            addToCartHP.dataset.atc = vehicleInfo.variantID;
            stageHPvalueSection(carInfo.brand, carInfo.model, carInfo.year, carInfo.details.hp, vehicleInfo.engineCode);

        } else {
            if (defaultProductPageDropdown) {
                defaultProductPageDropdown.style.display = "grid";
            }

            stageDefaultSection();
        }
    }

    function ppDefaultBreadCrumb() {
        fetch(window.location.href + ".js")
            .then(res => res.json())
            .then(data => {
                if (data) {
                    let brandModelTitleData = data.title.split("Chipwerke for")[1].trim();
                    const finalArrData = splitFirstAndLastData(brandModelTitleData);
                    const brandModelNewArray = brandModelSlice(finalArrData[0]);

                    let brandModelJsonData = data.options[0].values[0].split("/");

                    if (defaultPPBreadcrumb) {
                        defaultPPBreadcrumb.querySelector(".breadcrumb-brand").innerHTML = brandModelNewArray[0];
                        defaultPPBreadcrumb.querySelector(".breadcrumb-model").innerHTML = brandModelNewArray[1];
                        defaultPPBreadcrumb.querySelector(".breadcrumb-year").innerHTML = finalArrData[1];
                        defaultPPBreadcrumb.querySelector(".breadcrumb-engine").innerHTML = finalArrData[2];
                    }
                }
            })
            .catch((error) => {
                console.log(error);
                defaultPPBreadcrumb.remove();
            });
    }
    // banner main functions end

    // stage dynamic content start
    function stageDefaultSection() {
        fetch(window.location.href + ".js")
            .then(res => res.json())
            .then(data => {
                if (data) {
                    let brandModelJsonData = data.options[0].values[0].split("/");
                    let stockContentType = document.querySelector(".stock-content-type");
                    if (stockContentType) {
                        stockContentType.innerText = `Your ${brandModelJsonData[1]} ${brandModelJsonData[2]} offers ample power `;
                    }

                    let stageoneContentType = document.querySelector(".stageone-content-type");
                    if (stageoneContentType) {
                        stageoneContentType.innerText = "car";
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    function stageHPvalueSection(make, model, year, engine, hp) {
        let stockContentType = document.querySelector(".stock-content-type");
        if (stockContentType) {
            stockContentType.innerText = `Your ${make} ${model} (${year}) ${engine} makes ${hp}`;
        }

        let stageoneContentType = document.querySelector(".stageone-content-type");
        if (stageoneContentType) {
            stageoneContentType.innerText = engine;
        }
    }
    // stage dynamic content end

    // Helpers start
    function splitFirstAndLastData(input) {
        const firstDashIndex = input.indexOf('-');
        const lastDashIndex = input.lastIndexOf('-');

        if (firstDashIndex !== -1 && lastDashIndex !== -1 && firstDashIndex !== lastDashIndex) {
            const firstPart = input.substring(0, firstDashIndex).trim();
            const middlePart = input.substring(firstDashIndex + 1, lastDashIndex).trim();
            const lastPart = input.substring(lastDashIndex + 1).trim();

            return [firstPart, middlePart, lastPart];
        }

        return [input];
    }

    function brandModelSlice(input) {
        const parts = input.split(' ');
        const firstPart = parts[0];
        const remainingParts = parts.slice(1).join(' ');

        return [firstPart, remainingParts];
    }

    function fillBreadcrumbs() {
        let ppBreadcrumb = document.querySelector(".pp-breadcrumb");
        if (ppBreadcrumb) {
            ppBreadcrumb.querySelector(".breadcrumb-brand").innerHTML = vehicleInfo.brand;
            ppBreadcrumb.querySelector(".breadcrumb-model").innerHTML = vehicleInfo.model;
            ppBreadcrumb.querySelector(".breadcrumb-year").innerHTML = vehicleInfo.year;
            ppBreadcrumb.querySelector(".breadcrumb-engine").innerHTML = vehicleInfo.engineCode;
        }
    }
    // Helpers end


    // pp share start
    const shareImgProduct = document.querySelectorAll(".p-share");

    if (!navigator.share) {
        shareImgProduct.forEach((each) => (each.style.display = "none"));
    } else {
        shareImgProduct.forEach((each) => {
            each.addEventListener("click", (e) => {
                e.preventDefault();
                const shareData = {
                    title: "Chipwerke",
                    text: "Hey, I just stumbled upon , which increases your vehicle's horsepower. You should check it out!",
                    url: window.location.href,
                };
                navigator
                    .share(shareData)
                    .then(() => {
                        console.log("page was shared");
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            });
        });
    }
    // pp share end



    /* --- pp-banner.liquid end --- */



    /* --- pp-stages.liquid start --- */

    var targetStageSection = document.getElementById('start-observer-place');
    var animatedStagePointers = document.querySelectorAll(".stage-pointer-img ");

    // IntersectionObserver oluşturuyoruz
    var stageAnimObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            // Element viewport içindeyse
            if (entry.isIntersecting) {
                // console.log("stage ekranda")
                animatedStagePointers.forEach((item, index) => {
                    item.classList.add('stageanimpointer');
                })
            } else {
                // console.log("stage ekranda değil")
                animatedStagePointers.forEach((item, index) => {
                    item.classList.remove('stageanimpointer');
                })
            }
        });
    });

    stageAnimObserver.observe(targetStageSection);

    // ----------

    var defaultValue = document.querySelector("#defaultValue");
    var stage1Value = document.querySelector(".stage-1-Value");
    var stage2Value = document.querySelector(".stage-2-Value");

    var stage1Parent = document.querySelector("#stage-1-Parent");
    var stage2Parent = document.querySelector("#stage-2-Parent");

    var stage1Diff = document.querySelectorAll("#stage-1-diff");
    var stage2Diff = document.querySelectorAll("#stage-2-diff");

    var stage1Percentage = document.querySelector('#stage-1-Parent [role="progressbar"]');
    var stage2Percentage = document.querySelector('#stage-2-Parent [role="progressbar"]');

    var finalHpValueStage1 = document.querySelector(".finalHpValueStage1");
    var finalHpValueStage2 = document.querySelector(".finalHpValueStage2");

    // finalHpValueStage1.innerText = stage1Value.innerText+"HP";
    // finalHpValueStage2.innerText = stage2Value.innerText+"HP";

    var diffUIARRAY = [];

    function updateProgressBar(stageValue, progressBar, diff) {
        // console.log("diff ->", diff)
        let showUI = Math.round((parseInt(stageValue.innerText) / parseInt(defaultValue.innerText)) * 100 - 100);
        let diffUI = Math.round((parseInt(stageValue.innerText) - parseInt(defaultValue.innerText)));
        progressBar.style.setProperty('--value', showUI);

        let diffIncrement = diffUI / 100;
        let currentDiff = 0;
        setTimeout(() => {
            let diffInterval = setInterval(function () {
                currentDiff += diffIncrement;

                diff.forEach(item => {
                    item.innerText = Math.round(currentDiff);
                    if (currentDiff >= diffUI) {
                        clearInterval(diffInterval);
                        item.innerText = diffUI;


                        diffUIARRAY.push(diffUI);
                        // console.log("diffUIARRAY -->", diffUIARRAY);
                        let uniqueArr = [...new Set(diffUIARRAY)];
                        // console.log("uniqueArr -->", uniqueArr);

                        let minDiffValue = Math.min(...uniqueArr);
                        let maxDiffValue = Math.max(...uniqueArr);



                        finalHpValueStage1.innerText = parseInt(stage1Value.innerText) + "HP";
                        finalHpValueStage2.innerText = parseInt(stage2Value.innerText) + "HP";


                    }
                })


            }, 10)
        }, 1200)
    }

    const progressBars = document.querySelectorAll('div[role="progressbar"]');

    function flipCard() {
        const stageTabs = document.querySelectorAll(".stage-item-tab")
        const stageItems = document.querySelectorAll(".stage-item")

        for (let i = 1; i < stageTabs.length; i++) {
            progressBars[i - 1].style.animation = 'growProgressBar 3s 1 forwards';
            if (i == 1) {
                updateProgressBar(stage1Value, stage1Percentage, stage1Diff);
            } else if (i == 2) {
                updateProgressBar(stage2Value, stage2Percentage, stage2Diff);

            }

            stageTabs[i].addEventListener("click", () => {
                stageItems[i].style.transform = stageItems[i].style.transform === 'rotateY(180deg)' ? 'none' : 'rotateY(180deg)';
            })

        }
    }

    flipCard();

    /* --- pp-stages.liquid end --- */




    /* --- pp-unit-car.liquid start --- */

    let ppUnitStageFull = document.querySelector(".ppUnitStageFull");
    let innerContent = document.querySelectorAll("#pp-unit-car .content-part .inner-content");
    let stageCarUnitAnim = document.querySelector(".stage-car-unit-anim");

    let stageOpeningObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                ppUnitStageFull.classList.add('animate');

                setTimeout(() => {
                    if (window.innerWidth < 768) {
                        stageCarUnitAnim.style.animation = "unitTopAnimationMobile .5s linear forwards";
                    }
                    else {
                        stageCarUnitAnim.style.animation = "unitTopAnimationDesk .5s linear forwards";
                    }

                    setTimeout(() => {
                        innerContent.forEach(item => {
                            item.style.padding = "0 1rem 0";
                            let initialWidth = window.getComputedStyle(item).width;
                            item.style.width = "fit-content";
                            let finalWidth = window.getComputedStyle(item).width;
                            item.style.width = initialWidth;
                            setTimeout(() => {
                                item.style.width = finalWidth;
                            }, 50);
                        });
                    }, 500)

                }, 2500)

            }
        });
    });

    stageOpeningObserver.observe(ppUnitStageFull);

    /* --- pp-unit-car.liquid end --- */

});